import React from 'react'
import './SpecificPersonOrder.css'

const SpecificPersonOrder = ({children, personName, isSingleProduct}) => {
    return (
        <div className='specific-person-order'>
            <h4 className='personname'>{personName} placed {isSingleProduct ? "this" : "those"} order</h4>
            {children}
        </div>
    )
}

export default SpecificPersonOrder
